import { DeviceTypeEnum } from '@wm-front/admin/graphql'

declare const $localize: any

export function i18nDeviceType(val: DeviceTypeEnum): string {
  let res = ''

  switch (val) {
    case DeviceTypeEnum.Elevator:
      res = $localize`:Label | Type of device defined throughout the app@@i18nDeviceTypeElevatorLabel:Ascenseur`
      break
    case DeviceTypeEnum.Escalator:
      res = $localize`:Label | Type of device defined throughout the app@@i18nDeviceTypeEscalatorLabel:Escalator`
      break
    case DeviceTypeEnum.FireAlarm:
      res = $localize`:Label | Type of device defined throughout the app@@i18nDeviceTypeFireAlarmLabel:Sécurité incendie`
      break
    case DeviceTypeEnum.Door:
      res = $localize`:Label | Type of device defined throughout the app@@i18nDeviceTypeDoorLabel:Portes`
      break
    case DeviceTypeEnum.Hvac:
      res = $localize`:Label | Type of device defined throughout the app@@i18nDeviceTypeHvacLabel:CVC`
      break
    default:
      res = $localize`:Label | Type of device undefined throughout the app@@i18nDeviceTypeUndefinedLabel:inconnu`
  }
  return res
}
